import type Vue from 'vue';
import Bugsnag, { type Client, type Event, type NotifiableError, type OnErrorCallback } from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

interface AppConfig {
    apiKey?: string;
    releaseStage?: string;
}

type WindowUser = {
    id?: number | string;
    aclRole?: unknown;
};

let client: Client | undefined;

export const bugsnag = {
    notify(error: NotifiableError, onError?: OnErrorCallback) {
        client?.notify(error, onError);
    },
};

export function init(VueConstructor: typeof Vue, { apiKey, releaseStage }: AppConfig = {}) {
    if (!apiKey) return;

    client = Bugsnag.start({
        apiKey,
        releaseStage,
        plugins: [new BugsnagPluginVue()],
        collectUserIp: false,
        onError: (event: Event) => {
            const user = (window as Window & { user?: WindowUser }).user;

            if (user) {
                event.setUser(user.id === undefined ? undefined : String(user.id));
                event.addMetadata('user', {
                    aclRole: user.aclRole,
                });
            }
        },
    });

    Bugsnag.getPlugin('vue')?.installVueErrorHandler(VueConstructor);
}
